import { HttpStatus } from "@nestjs/common";

export class WsExceptionObject {
  message: string;
  status: number;

  static createExceptionObject(message: string, status: HttpStatus) {
    const e = new WsExceptionObject();
    e.message = message;
    e.status = status;
    return e;
  }
}
